<template>
  <div>
    <div v-if="chatInfo.isBlocked && chatInfo.blockedId == userId" class="at-chatblockuser" >
      <span> {{ TRANS.you_are_blocked }} </span>
    </div>
    <div v-else-if="chatInfo.isBlocked && chatInfo.blockedId != userId" class="at-chatblockuser" >
      <runtime-template-compiler :template="unblockButtonText" />
    </div>
    <!-- in case of group disable footer area  -->
    <template v-else-if="memberDisable.isDisable">
      <div class="at-leftgroupinfo at-leftgroup-footer">
        <span>{{memberDisable.disableText}}</span>
      </div>
    </template>
    <template v-else-if="disableReply(chatInfo.chatId) && (getUserRole == 0)">
      <div class="at-group-disabled"><span>{{TRANS.disable_reply_txt}}</span></div>
    </template>
    <template v-else>
      <div class="at-replay" :class="{'at-replay_disable' : isDisabledFooter(chatInfo.chatId) }">
        <guppy-chat-quoted-messages @removeQuoteMessage="removeQuote();" v-if="quoteMessage" :quoteMsgProps="quoteMessage"/>
        <span v-html="typingUsers" class="at-typing"></span>
        <send-text-message :chatId="chatInfo.chatId"/>  
      </div>
      <ul class="at-chat_sidebar_footer">
        <li>
          <media-messages :chatId="chatInfo.chatId"/>
        </li>
        <li>
          <send-voice-message :chatId="chatInfo.chatId" />
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import GuppyChatQuotedMessages from "../GuppyChatMessages/GuppyChatQuotedMessages/GuppyChatQuotedMessages.vue";
import GuppyChatSendTextMessage from "../GuppyChatMessages/GuppyChatMessageFooter/GuppyChatSendTextMessage.vue";
import { GUPPYCHAT_SETTINGS , GUPPYCHAT_TRANSLATION } from "../../resources/constants";
import GuppyChatSendMediaMessage from "../GuppyChatMessages/GuppyChatMessageFooter/GuppyChatSendMediaMessage.vue";
import GuppyChatSendVoiceMessage from "../GuppyChatMessages/GuppyChatMessageFooter/GuppyChatSendVoiceMessage.vue";
import { mapGetters } from 'vuex';


export default {
  name : "GuppywidgetChatBoxFooter",
  components:{
    GuppyChatQuotedMessages,
    SendTextMessage : GuppyChatSendTextMessage,
    MediaMessages : GuppyChatSendMediaMessage,
    SendVoiceMessage : GuppyChatSendVoiceMessage,
  },
  props:{
    'chatInfo':{
        type: Object,
        required : true,
        default : ()=>{
          return new Object();
        }
      },
  },
  data: () => {
    return {
    }
  },
  computed:{
    getUserRole(){
      return this.$store.getters.getUserRole(this.chatInfo.chatId)
    },
    memberDisable(){
      return this.$store.getters.memberDisable(this.chatInfo.chatId);
    },
    disableReply(){
      return this.$store.getters.disableReply(this.chatInfo.chatId);
    },
    unblockButtonText() {
      let text        = GUPPYCHAT_TRANSLATION.blocked_user_message;
      let buttonText  = GUPPYCHAT_TRANSLATION.unblock_now;
      let button      = '<a href="javascript:;" @click.prevent="updateSelectChatId()" guppy-data-target="#blockuser">' + buttonText + " </a>";
      let updatedText = `<span>${text.replace("%Unblock%", button)}</span>`;
      return updatedText;
    },
     typingUsers(){
        let data          = this.$store.getters.typingUsersIndicatorText(this.chatInfo.chatId);
        let isTypingText    = GUPPYCHAT_TRANSLATION.is_typing
        let areTypingText   = GUPPYCHAT_TRANSLATION.are_typing
        let moreTypingText  = GUPPYCHAT_TRANSLATION.more_user_typing
        let indicator = data.indicator , typingUsers = data.typingUsers, tUsers = data.tUsers, typingText = '';
        if( tUsers ){
          if( indicator == 'isTypingText' && typingUsers ){
            typingText = `<em class="at-typing-name">${typingUsers}</em>${isTypingText}`;
          } else if( indicator == 'areTypingText' && typingUsers ){
            typingText = `<em class="at-typing-name">${typingUsers}</em>${areTypingText}`;
          } else {
            let moreText = `<em class="at-typing-name">${typingUsers}</em>${moreTypingText}`;
            typingText = moreText.replace('((user_count))', Number(tUsers)-3 )
          }
          typingText +='<em><img src="'+GUPPYCHAT_SETTINGS.typingIcon+'" alt="users typing"></em>';
        }
        return typingText
      },
      quoteMessage : function(){
        return this.$store.getters.getQuoteMessage(this.chatInfo.chatId)
      },
      quoteMessageId(){
        return this.$store.getters.getQuoteMessageId()
      },
    ...mapGetters({
      'disableReply'    : 'disableReply',
      'isDisabledFooter': 'isDisabledFooter',
    }),
  },
  methods:{
    updateSelectChatId() {
      this.$store.commit('updateSelectedChatId', {chatId : this.chatInfo.chatId})
    },
    removeQuote(){
      this.$store.commit('removeQuote', {chatId: this.chatInfo.chatId});
    },
  }
}
</script>
<style scoped>
  .at-floatchat_content .at-replay_msg {
    padding: 0;
}
.at-floatchat_content .at-replay_msg input {
    height: 40px;
    border-radius: 3px;
}
.at-replay_msg > a:not(.at-sendmsg) + input {
    padding-right: 60px;
}
.at-floatchat_content .at-replay_msg input {
    height: 40px;
    border-radius: 3px;
}
.at-floatchat_content .at-replay{
  display: block;
  border-top: 1px solid #DDDDDD;
  background-color: #f7f7f7;
}
.at-floatchat_content .at-replay_msg > a:not(.at-sendmsg) {
  right: 21px;
}
.at-floatchat_content .at-chat_sidebar_footer {
  position: static;
}
.at-floatchat_content .at-chat_sidebar_footer li {
  padding: 0 !important;
  width: 100% !important;
}
.at-floatchat_content .at-chat_sidebar_footer li > div{width: 100%;}
.at-floatchat_content .at-chat_sidebar_footer a {
  padding: 18px 15px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.at-floatchat_content .at-chat_sidebar_footer a.active {
  color: #fff;
  background-color: #FF7300;
}
</style>